<template>
    <div>
        <lv1-fiera v-if="this.f_modalita_fiera" :configurazioni="this.configurazioni" :currType="this.currType"/>
        <nav v-else class="nav nav-pills flex-row justify-content-center nav-type my-3 my-md-4">
            <button class="flex-sm-fill btn btn-type" type="button" v-if="this.takeaway.f_attivo"
                    :class="{active: this.currType === 'takeaway'}" @click="$emit('onButtonPress', 'takeaway')">
                {{$t("takeaway")}}
            </button>
            <button class="flex-sm-fill btn btn-type" type="button" v-if="this.delivery.f_attivo"
                    :class="{active: this.currType === 'delivery'}" @click="$emit('onButtonPress', 'delivery')">
                {{$t("delivery")}}
            </button>
            <button class="flex-sm-fill btn btn-type" type="button" v-if="this.mangia_ristorante.f_attivo"
                    :class="{active: this.currType === 'mangia_ristorante'}"
                    @click="$emit('onButtonPress', 'mangia_ristorante')">
                {{$t("eat_at_restaurant")}}
            </button>
            <button type="button" class="btn btn-type ml-4" v-if="this.ordina_tavolo.f_attivo"
                    @click="$emit('onButtonPress', 'ordina_tavolo')"
                    :class="{active: this.currType === 'ordina_tavolo'}">
                {{$t("al_tavolo")}}
            </button>
            <button class="flex-sm-fill btn btn-type" type="button"
                    v-if="!this.f_modalita_fiera && this.dil.f_attivo"
                    :class="{active: this.currType === 'dil'}" @click="$emit('onButtonPress', 'dil')">
                {{this.dil.label_tipologia}}
            </button>
        </nav>
        <lv1-delivery
            v-if="this.currType === 'delivery' && this.delivery.f_modalita_fasce_zona && !this.delivery.f_forza_blocco"
            :conf="this.delivery"
            :address="this.address"
            @onIndirizzoManualeCittaPicked="this.onIndirizzoManualeCittaPicked"
            @onIndirizzoManualeZonaPicked="this.onIndirizzoManualeZonaPicked"
            @onIndirizzoCoordinatePicked="this.onIndirizzoCoordinatePicked"
        />
        <lv1-dil v-if="!this.f_modalita_fiera && this.currType === 'dil' && !this.dil.f_forza_blocco"
                 :conf="this.dil" :point="this.point"
                 @onPointPicked="this.onPointPicked"/>
        <lv1-ordina-tavolo v-if="this.currType === 'ordina_tavolo' && !this.ordina_tavolo.f_forza_blocco"
                           :table="this.table"
                           @onQrCodeDecoded="this.onQrCodeDecoded"
                           @onQrCodeScanAgain="this.onQrCodeScanAgain"
        />
    </div>
</template>

<script>
import {mapState} from "vuex";

import Lv1Delivery from "./Lv1Delivery";
import Lv1Fiera from "./Lv1Fiera";
import Lv1Dil from "./Lv1Dil";
import Lv1OrdinaTavolo from "./Lv1OrdinaTavolo";

export default {
    name: "Lv1",
    components: {Lv1OrdinaTavolo, Lv1Dil, Lv1Fiera, Lv1Delivery},
    props: ['initType', 'configurazioni', 'currType', 'address', 'point', 'table'],
    computed: {
        delivery: function () {
            return this.configurazioni.delivery;
        },
        takeaway: function () {
            return this.configurazioni.takeaway;
        },
        mangia_ristorante: function () {
            return this.configurazioni.mangia_ristorante;
        },
        dil: function () {
            return this.configurazioni.dil;
        },
        ordina_tavolo: function () {
            return this.configurazioni.ordina_tavolo;
        },
        ...mapState('restaurant', {
            f_modalita_fiera: state => state.f_modalita_fiera
        })
    },
    mounted() {
        if (this.initType) {
            this.$emit('onButtonPress', this.initType);
        }
    },
    methods: {
        onIndirizzoManualeCittaPicked: function (citta) {
            this.$emit('onIndirizzoManualeCittaPicked', citta);
        },
        onIndirizzoManualeZonaPicked: function (zona) {
            this.$emit('onIndirizzoManualeZonaPicked', zona);
        },
        onIndirizzoCoordinatePicked: function (geocodeResult, formattedAddress, houseNumber) {
            this.$emit('onIndirizzoCoordinatePicked', geocodeResult, formattedAddress, houseNumber);
        },
        onPointPicked: function (point) {
            this.$emit('onPointPicked', point);
        },
        onQrCodeDecoded: function (table) {
            this.$emit('onQrCodeDecoded', table);
        },
        onQrCodeScanAgain: function () {
            this.$emit('onQrCodeScanAgain');
        }
    }
}
</script>
